var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 751,
    viewBox: "0 0 1440 751",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1424.78 749.932C954.663 637.6 484.545 637.6 14.442 749.932",
    stroke: "url(#paint0_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.56 450.744C968.395 428.275 471.225 428.275 -25.9313 450.744",
    stroke: "url(#paint1_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.97 599.783C963.826 532.391 475.67 532.391 -12.4736 599.783",
    stroke: "url(#paint2_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.78 1.06836C954.663 113.399 484.545 113.399 14.442 1.06836",
    stroke: "url(#paint3_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.78 1.06836C954.663 113.399 484.545 113.399 14.442 1.06836",
    stroke: "url(#paint4_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.56 300.968C968.395 323.438 471.225 323.438 -25.9313 300.968",
    stroke: "url(#paint5_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.97 150.47C963.826 217.862 475.67 217.862 -12.4736 150.47",
    stroke: "url(#paint6_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.97 150.47C963.826 217.862 475.67 217.862 -12.4736 150.47",
    stroke: "url(#paint7_linear_2046_2733)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2046_2733",
    x1: 14.442,
    y1: 707.807,
    x2: 1424.78,
    y2: 707.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#6101A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#6101A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2046_2733",
    x1: -25.9313,
    y1: 442.319,
    x2: 1465.56,
    y2: 442.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2046_2733",
    x1: -12.4736,
    y1: 574.512,
    x2: 1451.97,
    y2: 574.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#51018E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2046_2733",
    x1: 14.1449,
    y1: 1.06836,
    x2: 1425.08,
    y2: 1.06823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2046_2733",
    x1: 14.442,
    y1: 43.1927,
    x2: 1424.78,
    y2: 43.1926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201737,
    stopColor: "#3D0172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763248,
    stopColor: "#2C015A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2046_2733",
    x1: -25.9313,
    y1: 309.395,
    x2: 1465.56,
    y2: 309.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313845,
    stopColor: "#51018E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688597,
    stopColor: "#50018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2046_2733",
    x1: -12.7822,
    y1: 150.47,
    x2: 1452.28,
    y2: 150.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#C9C9C9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2046_2733",
    x1: -12.4736,
    y1: 175.741,
    x2: 1451.97,
    y2: 175.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F0047"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.0b95fbea46de8bdd853d41d3587ea5cc.svg";
export { ForwardRef as ReactComponent };